module.exports = __webpack_public_path__ + "static/media/pulverizador.477c55f4.svg";